// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// eslint-disable-next-line
import Vue from 'vue';
import moment from 'moment';
import App from './App';
import router from './router';
import { getUrlParams } from './utils/util';
import service from './utils/axios.js';
import axios from 'axios';
import { ACCESS_TYPE } from '@/constants';
// 引入lke统一渲染插件
import lkeComponent from 'lke-component';

Vue.use(lkeComponent);
const vhtml = window.vhtml;
Vue.use(vhtml);
vhtml.install(Vue);

try {
    let iconpath = 'https://cdn3.codesign.qq.com/icons/XzKaDZdEa7j2GPL/latest/iconfont.js';
    vhtml.Icon.setDefaultRemoteSrc && vhtml.Icon.setDefaultRemoteSrc(iconpath);
} catch (e) {
    console.log('load remote icon error');
}

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;

    console.log(window.$initType);
    console.log(to.name);
    const sessionValue = sessionStorage.getItem('refresh');
    console.log(sessionValue);

    if(sessionValue === "true"){

      window.location.reload();
      console.log("刷新页面");
      sessionStorage.setItem("refresh", "false");

    };
    // if (to.name && window.$initType !== to.name && to.name !== 'form') {
    //     window.location.reload();
    // }
    next();
});

let webIMType; // 后端ws识别的端类型
let webIMSource; // 前端区分UI交互的端类型

webIMType = [5];
window.$initTypeKey = 5;
webIMSource = 'client';

Vue.prototype.webIMSource = webIMSource;

Object.defineProperty(window, 'userType', {
    writable: false,
    enumerable: false,
    configurable: false,
    value: 2
});

window.$initType = 'assistantAi';

console.log('【init msg-------ACCESS_TYPE---->】', ACCESS_TYPE);

let tokenGet = webIMType.map(type => {
    // 调用函数解析 URL 参数
    const urlParams = getUrlParams(window.location.href);
    console.log('【init ------>333】', urlParams);

    return new Promise(async (resolve, reject) => {
        let demoToken = '9e234da2-3aad-4343-b15a-f80b89499052';
        if (ACCESS_TYPE === 'ws') {
            let _url = process.env.NODE_ENV == 'production'? '/ai/robot/token': '/api/ai/robot/token';
            let ceate_session_url = process.env.NODE_ENV == 'production'? '/api/agent/session': '/api/agent/session';
            let get_token_url = process.env.NODE_ENV == 'production'? '/api/agent/token?appType=1': '/api/agent/token?appType=1';

          try {
            let payload = {};
            if(urlParams.formsource == 'lysm') {
              payload.projectId = urlParams.projectId;
            }
            const responseToken = await service.get(get_token_url);
            console.log('responseToken----2', responseToken)

            if(responseToken.data) {
              demoToken = responseToken.data
            }

            const response = await service.post(ceate_session_url, payload);
            if(response.data) {
              window.waitSessionData = null;
              window.sessionData = response.data;
            }else {
              window.waitSessionData = response;
            }
            if(response.code == 3000) {
              console.log('refreshParent-------main')
              // window.parent.postMessage(
              //     { type: "refreshParent" },window.location.origin
              //   );
              alert('会话状态已过期，请刷新重试');
              return
            }
            if(urlParams.formsource == 'lysm'&&response.code == 3000) {
              // 发送消息给小程序
              window.postMessage({
                type: 'showToast',
                content: response.message
              }, '*');
            }
          } catch (error) {
            console.error('请求出错:', error);
          }

        }
        console.log('***********2',demoToken)
        let result = {
            type: type,
            token: demoToken,
            access: ACCESS_TYPE
        };
        console.log('【init msg----------demoToken---->】', result);
        resolve(result);
    });
});


Promise.all(tokenGet).then(res => {
    Object.defineProperty(window, 'webimToken', {
        writable: false,
        enumerable: false,
        configurable: false,
        value: res
    });
    if (ACCESS_TYPE === 'ws') {
        (async () => {
            let mixin = await import('@/manage/index');
            Vue.mixin(mixin);
            /* eslint-disable no-new */
            new Vue({
                el: '#app',
                router,
                render (h) {
                    return h(App);
                }
            }).$mount('#app');
        })();
    } else {
        (async () => {
            let sseMixin = await import('@/manage/sse');
            Vue.mixin(sseMixin);
            /* eslint-disable no-new */
            new Vue({
                el: '#app',
                router,
                render (h) {
                    return h(App);
                }
            }).$mount('#app');
        })();
    }
}).catch(e => {
});

// 加载统计代码
import GrowingIO from '../scripts/growingio.js';
Vue.use(GrowingIO);



// WEBPACK FOOTER //
// ./src/main.js